import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  Select,
  MenuItem,
} from '@material-ui/core'

import * as UnitActionCreators from '../../actions/unit'

class DeviceSelectContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    devices: PropTypes.object.isRequired,
    devicesByUnit: PropTypes.object.isRequired,
    unitActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    value: null,
  }

  static mapStateToProps(state) {
    return {
      devices: state.devices,
      devicesByUnit: state.devicesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { unitId, unitActions } = this.props
    unitActions.listUnitDevices(unitId)
  }

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  deviceIds() {
    return this.props.devicesByUnit[this.props.unitId] || []
  }

  devices() {
    const unitDevices = []
    this.deviceIds().forEach((id) => {
      unitDevices.push(this.props.devices[id])
    })
    return unitDevices
  }

  render() {
    const {
      unitId, value, onChange, devices, devicesByUnit, unitActions,
      ...props
    } = this.props

    return (
      <Select value={value} onChange={this.onChange} {...props}>
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {this.devices().map((device) => (
          <MenuItem key={device.id} value={device.id}>
            {device.id}
          </MenuItem>
        ))}
      </Select>
    )
  }
}

export default connect(
  DeviceSelectContainer.mapStateToProps,
  DeviceSelectContainer.mapDispatchToProps,
)(DeviceSelectContainer)
